import React, { useEffect, useState } from "react";
import { Grid, Typography } from "@mui/material";
import { injectIntl } from "react-intl";
import { StyleHeading, StyleTypography } from "../../assets/js/Theme";
import CustomChart from "../../components/CustomChart";
import {
  getMarketData,
  getDynamicPriceIndex,
} from "../../crud/chart.crud";
import { DEVICE_WIDTH, DUBAI, IS_MOBILE_WIDTH } from "../../resources/Constants";
import { isMobileWidth } from "../../resources/utils";
function IndexAndVolume(props) {
  const { intl, overallResults, reportHash } = props;
  const TIME_PERIOD = 6;
  const initialData = {
    data: [],
    period: [],
  };
  // const reportId = overallResults?.reportId || "";
  const [dpiTransactions, setDpiTransactions] = useState(initialData);
  // const [dpiTransactionsLoaded, setDpiTransactionsLoaded] = useState(false);
  const [actTransactions, setActTransactions] = useState(initialData);
  const [actTransactionsLoaded, setActTransactionsLoaded] = useState(false);
  const [dldTransactions, setDldTransactions] = useState(initialData);
  const [dldTransactionsLoaded, setDldTransactionsLoaded] = useState(false);
  const [totalDldTransactions, setTotalDldTransactions] = useState();
  const [totalActTransactions, setTotalActTransactions] = useState();
  // const [graphsLoaded, setGraphsLoaded] = useState({
  //   pmdpi: false,
  //   tra: false,
  //   act: false,
  // });
  const [subjectLocation, setSubjectLocation] = useState("");
  const _fetchMarketData = async (values) => {
    try {
      let tempTransactions = [];
      let tempPeriods = [];
      let total = 0;
      const queryParams = {
        emirateId: values.emirateId || DUBAI,
        evidenceType: values.evidenceType || "",
        unitSizeSqft: overallResults?.unitSizeSqft || "",
        plotSizeSqft: overallResults?.plotSizeSqft || "",
        propertyTypeId: overallResults?.propertyTypeId || "",
        locationId: overallResults?.locationId || "",
        bedrooms: overallResults?.bedrooms || "",
        bathrooms: overallResults?.bathrooms || "",
        timePeriod: TIME_PERIOD,
        // reportId,
        // limit: LIMIT,
        reportHash,
      };
      const result = await getMarketData(queryParams);
      const { status, data, location } = result.data;
      if (status === 1) {
        setSubjectLocation(location);
        if (data.length) {
          data.forEach((element) => {
            const periodEntry = `${element.mn_name} ${element.yr}`;
            const transEntry = element?.total_rows || 0;
            tempPeriods = [...tempPeriods, periodEntry];
            tempTransactions = [...tempTransactions, transEntry];
            total = element.total_rows + total;
          });
          const dataToInsert = {
            data: tempTransactions,
            period: tempPeriods,
          };
          if (values.evidenceType === "ACT") {
            // graphsLoaded.act = true;
            // setGraphsLoaded(graphsLoaded);
            setActTransactions(dataToInsert);
            setTotalActTransactions(total);
            setActTransactionsLoaded(true);
          } else {
            // setTimeout(() => {
            // graphsLoaded.tra = true;
            // setGraphsLoaded(graphsLoaded);
            setDldTransactions(dataToInsert);
            setTotalDldTransactions(total);
            setDldTransactionsLoaded(true);
            // }, 2000);
          }
        } else {
          // if there is no data, cant set above as the data needs to populate

          if (values.evidenceType === "ACT") {
            // graphsLoaded.act = true;
            // setGraphsLoaded(graphsLoaded);
            setActTransactionsLoaded(true);
          } else {
            // graphsLoaded.tra = true;
            // setGraphsLoaded(graphsLoaded);
            setDldTransactionsLoaded(true);
          }
        }
      } else {
        console.log("data are not populated");
      }
    } catch (e) {
      console.log(e);
    }
  };
  const _getDynamicPriceIndex = async (values) => {
    try {
      let tempPrices = [];
      let tempPeriods = [];
      const queryParams = {
        emirateId: DUBAI,
        // reportId,
        // timePeriod:TIME_PERIOD
        // limit: LIMIT,
        reportHash,
      };
      const result = await getDynamicPriceIndex(queryParams);
      // graphsLoaded.pmdpi = true
      // setGraphsLoaded(graphsLoaded)
      const { status, data } = result.data;
      if (status === 1) {
        // setDpiTransactionsLoaded(true)
        if (data.length) {
          data.forEach((element) => {
            const periodEntry = `${element.mn_name} ${element.yr}`;
            const priceEntry = element?.index_value || 0;
            tempPeriods = [...tempPeriods, periodEntry];
            tempPrices = [...tempPrices, priceEntry];
          });
          const dataToInsert = {
            data: tempPrices,
            period: tempPeriods,
          };
          // setTimeout(() => {
          setDpiTransactions(dataToInsert);
          // }, 1000);
        }
      } else {
        console.log("data are not populated");
      }
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    const queryParam = {
      evidenceType: "ACT",
    };
    _fetchMarketData(queryParam);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    const queryParam = {
      evidenceType: "TRA",
    };
    _fetchMarketData(queryParam);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    _getDynamicPriceIndex();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      <Grid container>
        <Grid item xs={12} className="section--heading--wrapper">
          <hr />
          <StyleHeading
            color="secondary"
            className="heading--text"
            variant="h1"
          >
            {intl.formatMessage({
              id: "INDEX.HEADING.MARKET_TRENDS",
            })}
          </StyleHeading>
          <hr />
        </Grid>
        <Grid item xs={12}>
          <StyleHeading color="primary" variant="h2" gutterBottom>
            {intl.formatMessage({
              id: "INDEX.HEADING.DYNAMIC_PRICE_INDEX",
            })}
          </StyleHeading>
          <Grid item xs={12}>
            <StyleTypography color="primary" gutterBottom>
              {intl.formatMessage({
                id: "EXPLANATION_DYNAMIC_HOUSE_PRICE_INDEX",
              })}
            </StyleTypography>
          </Grid>
        </Grid>
        {dpiTransactions.data.length ? (
          <Grid item xs={12} className="price--index--wrapper" style={DEVICE_WIDTH <= IS_MOBILE_WIDTH ? isMobileWidth : null}>
            <CustomChart
              // storeImageOnServer
              // dataLoaded={dpiTransactions.data.length}
              // reportHash={reportHash}
              // graphsLoaded={graphsLoaded}
              // setDownloadReportDisabled={setDownloadReportDisabled}
              // title={"pmdpi"}
              chartType="areaspline"
              chartHeight={600}
              chartLabel=""
              gridLineColor="#DDDDDD"
              showPlotLine={[
                {
                  color: "red",
                  width: 2,
                  value: 100,
                  dashStyle: "shortdash",
                  label: {
                    text: intl.formatMessage({
                      id: "INDEX.LABEL.INDEXED_BASED_VALUE_100",
                    }),
                    align: "right",
                    style: {
                      color: "red",
                      zIndex: 100,
                      position: "relative",
                    },
                  },
                },
              ]}
              xAxisValue={dpiTransactions.period}
              yAxisTitle={intl.formatMessage({
                id: "INDEX.LABEL.INDEX_VALUE",
              })}
              tooltipLabel=""
              data={[
                {
                  name: intl.formatMessage({
                    id: "INDEX.LABEL.MONTHLY",
                  }),
                  color: "#ff6a15",
                  data: dpiTransactions.data,
                },
              ]}
              minYScale={90}
              maxYScale={dpiTransactions?.data?.length ? Math.max(...dpiTransactions.data) + 20 : 300}
              yInterval={10}
            />
          </Grid>
        ) : null}
      </Grid>
      <Grid container className="market--activity--wrapper">
        <Grid item xs={12}>
          <Grid container>
            <Grid item xs={12}>
              <StyleHeading
                color="primary"
                align="center"
                variant="h2"
                gutterBottom
              >
                {intl.formatMessage({
                  id: "INDEX.HEADING.LOCAL_MARKET_ACTIVITY",
                })}
              </StyleHeading>
            </Grid>
          </Grid>
          <Grid
            container
            alignItems="center"
            className="volume--graph--wrapper"
            spacing={3}
          >
            <Grid item xs={12} md={4}>
              <Typography
                align="center"
                color="primary"
                variant="h2"
                className="graph--value--left"
              >
                {totalDldTransactions || "0"}
              </Typography>
              <Typography
                align="center"
                color="primary"
                paragraph
                className="graph--label--left"
              >
                {intl.formatMessage(
                  {
                    id: "INDEX.LABEL.NUMBER_OF_TRANSFER",
                  },
                  {
                    time: TIME_PERIOD,
                    type: "sold and transferred",
                    location: subjectLocation,
                  }
                )}
              </Typography>
            </Grid>
            <Grid item xs={12} md={8} style={DEVICE_WIDTH <= IS_MOBILE_WIDTH ? isMobileWidth : null}>
              {dldTransactionsLoaded && (
                <CustomChart
                  // dataLoaded={dldTransactionsLoaded}
                  // storeImageOnServer
                  // reportHash={reportHash}
                  // graphsLoaded={graphsLoaded}
                  // setDownloadReportDisabled={setDownloadReportDisabled}
                  // title={"no of transactions sold"}
                  chartType="column"
                  chartHeight={350}
                  chartLabel={intl.formatMessage({
                    id: "INDEX.LABEL.NUMBER_OF_TRANSACTION_SOLD",
                  })}
                  gridLineColor="#1c3545"
                  xAxisValue={dldTransactions.period}
                  yAxisTitle=""
                  tooltipLabel=""
                  data={[
                    {
                      name: intl.formatMessage({
                        id: "INDEX.LABEL.MONTHLY",
                      }),
                      color: "#1c3545",
                      data: dldTransactions.data,
                    },
                  ]}
                  noDataMessage={`${intl.formatMessage({
                    id: "INDEX.CHART.NO_DLD_DATA",
                  })} ${subjectLocation}`}
                />
              )}
            </Grid>
          </Grid>
          <Grid
            container
            alignItems="center"
            className="volume--graph--wrapper"
            spacing={3}
          >
            <Grid item xs={12} md={4}>
              <Typography
                align="center"
                color="secondary"
                variant="h1"
                className="graph--value--left"
              >
                {totalActTransactions || "0"}
              </Typography>
              <Typography
                align="center"
                color="primary"
                paragraph
                className="graph--label--left"
              >
                {intl.formatMessage(
                  {
                    id: "INDEX.LABEL.NUMBER_OF_TRANSFER",
                  },
                  {
                    time: TIME_PERIOD,
                    type: "publicly listed for sale",
                    location: subjectLocation,
                  }
                )}
              </Typography>
            </Grid>
            <Grid item xs={12} md={8} style={DEVICE_WIDTH <= IS_MOBILE_WIDTH ? isMobileWidth : null}>
              {actTransactionsLoaded && (
                <CustomChart
                  // storeImageOnServer
                  // dataLoaded={actTransactionsLoaded}
                  // setDownloadReportDisabled={setDownloadReportDisabled}
                  // reportHash={reportHash}
                  // graphsLoaded={graphsLoaded}
                  // title={"no of active listings"}
                  chartType="column"
                  chartHeight={350}
                  chartLabel={intl.formatMessage({
                    id: "INDEX.LABEL.NUMBER_OF_ACTIVE_LISTINGS",
                  })}
                  gridLineColor="#1c3545"
                  xAxisValue={actTransactions.period}
                  yAxisTitle=""
                  tooltipLabel=""
                  data={[
                    {
                      name: intl.formatMessage({
                        id: "INDEX.LABEL.MONTHLY",
                      }),
                      color: "#ff6a15",
                      data: actTransactions.data,
                    },
                  ]}
                  noDataMessage={`${intl.formatMessage({
                    id: "INDEX.CHART.NO_ACT_DATA",
                  })} ${subjectLocation}`}
                />
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}

export default injectIntl(IndexAndVolume);
